import React from 'react';

export default function Statement(){

    return(
        <div className='statement' id='clubpage'>
           <h1>Part of the University's Management & Design Clubs</h1>
        </div>
    );
}